import { render, staticRenderFns } from "./TaskTemplateNew.vue?vue&type=template&id=7064acf0&"
import script from "./TaskTemplateNew.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports